import React from "react";
import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";
import useStyled from "../../hooks/useStyled";
import Arrow from "../icons/carouselArrow.js";

const { styled } = useStyled();

const SFSplideContainerStyled = styled("div")(({ theme }) => ({
  "& .splide__list": {
    paddingTop: "24px !important",
    paddingBottom: "24px !important",
  },
  "&:hover": {
    "& .splide__arrow": {
      display: "block",
    },
  },
  "&:focus-within": {
    "& .splide__arrow": {
      display: "block",
    },
  },
  // Style for custom navigation arrows
  "& .splide__arrow": {
    display: "none",
    backgroundColor: "transparent",
    height: 80,
    width: 80,
    "& svg": {
      width: 80,
      height: 80,
    },
  },
  // Move navigation arrows to the edge of the screen
  "& .splide__arrow--next": {
    transform: "translateX(11px) translateY(-50%)",
  },
  "& .splide__arrow--prev": {
    transform: "translateX(-11px) translateY(-50%)",
  },
  // Show the navigation arrows only on hover
  "& .splide__arrow:disabled": {
    opacity: 0,
    pointerEvents: "none",
  },
  "& .splide__pagination": {
    justifyContent: "flex-end",
    marginRight: 75,
    marginBottom: 44,

    "& li": {
      marginLeft: 20,
      "& .splide__pagination__page": {
        width: 9,
        height: 9,
      },
    },
    "& .splide__pagination__page": {
      background: theme.palette.grey400.main,
      "&.is-active": {
        background: theme.palette.white.main,
        transform: "none",
      },
    },
  },
}));

// Splide slide container with custom navigation arrows
const SFSplideContainer = ({ children, options }) => {
  return (
    <SFSplideContainerStyled>
      <Splide options={options} hasTrack={false}>
        <SplideTrack>
          {Array.isArray(children) &&
            children.map((item, index) => (
              <SplideSlide key={index}>{item}</SplideSlide>
            ))}
        </SplideTrack>
        <div className="splide__arrows">
          <button className="splide__arrow splide__arrow--prev">
            <Arrow />
          </button>
          <button className="splide__arrow splide__arrow--next">
            <Arrow />
          </button>
        </div>
      </Splide>
    </SFSplideContainerStyled>
  );
};

export default SFSplideContainer;
